import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";

// 默认查询数据
export const DEFAULT_QUERY_DATA = {
    Status: undefined,
};

// 默认分页数据
export const DEFAULT_PAGE_DATA = {
    Page: 1,
    PageSize: 10,
    Total: 0,
};

// 生成查询表单配置
export const generateQueryFormConfig = (): FormConfigType => {
    return [
        {
            title: "状态",
            field: "Status",
            type: "select",
            placeholder: "请选择状态",
            options: [
                { name: "全部", id: undefined },
                { name: "可用", id: 1 },
                { name: "禁用", id: 2 },
            ],
            style: {
                width: 200
            }
        },
    ];
};

// 生成表格列配置
export const generateTableColumns = (): ColumnsType => {
    return [
        {
            title: "ID",
            dataIndex: "Id",
            key: "Id",
        },
        {
            title: "国家代码",
            dataIndex: "Code",
            key: "Code",
        },
        {
            title: "国家名称",
            dataIndex: "Name",
            key: "Name",
        },
        {
            title: "国家中文名称",
            dataIndex: "NameCn",
            key: "NameCn",
        },
        {
            title: "货币代码",
            dataIndex: "CurrencyCode",
            key: "CurrencyCode",
        },
        {
            title: "滑点比例",
            dataIndex: "SlippageRate",
            key: "SlippageRate",
        },
        {
            title: "排序",
            dataIndex: "Sort",
            key: "Sort",
        },
        {
            title: "状态",
            dataIndex: "Status",
            key: "Status",
            render: (text: number) => {
                const statusMap: Record<number, string> = {
                    1: "可用",
                    2: "禁用",
                };
                return statusMap[text] || "未知";
            }
        },
        {
            title: "创建时间",
            dataIndex: "CreatedAtString",
            key: "CreatedAtString",
        }, 
    ];
};
